import { Link } from "react-router-dom";
import { ShieldCheck, Video, Stethoscope } from "lucide-react";
import Logo from "@/components/Logo";
import ConsultFlow from "@/components/ConsultFlow";

// Standalone online-consultation page — same distraction-free layout as /book.
export default function Consultation() {
  return (
    <div className="flex min-h-screen flex-col bg-sa-bg" data-testid="consult-page">
      <header className="mx-auto flex w-full max-w-6xl items-center justify-between px-6 py-5">
        <Link to="/" data-testid="consult-logo">
          <Logo iconClass="h-9 w-9" textClass="text-xl" />
        </Link>
        <Link
          to="/book"
          data-testid="consult-book-link"
          className="text-sm font-medium text-sa-muted transition-colors hover:text-sa-forest"
        >
          Book an evaluation
        </Link>
      </header>

      <main className="flex flex-1 items-start justify-center px-4 pb-16 pt-6 sm:items-center sm:pt-0">
        <div className="w-full max-w-md rounded-[28px] border border-sa-beige bg-white p-6 shadow-[0_24px_60px_-24px_rgba(10,46,34,0.18)] sm:p-7">
          <ConsultFlow />
        </div>
      </main>

      <footer className="pb-8">
        <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-[13px] text-sa-muted">
          <span className="flex items-center gap-1.5">
            <Stethoscope className="h-4 w-4 text-sa-copper" /> Physician-Led
          </span>
          <span className="flex items-center gap-1.5">
            <ShieldCheck className="h-4 w-4 text-sa-copper" /> Private & Secure
          </span>
          <span className="flex items-center gap-1.5">
            <Video className="h-4 w-4 text-sa-copper" /> From Anywhere in India
          </span>
        </div>
      </footer>
    </div>
  );
}
